import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/table/table.js';
      import {ObcTableRowClickEvent, ObcTableCellClickEvent, ObcTableCellCheckboxChangeEvent, ObcTableCellTagClickEvent, ObcTableSelectionChangeEvent, ObcTableRow, ObcTableColumn, ObcTableCellData} from '@oicl/openbridge-webcomponents/dist/components/table/table.js';

      export interface Props {
     data?: ObcTableRow[];
     columns?: ObcTableColumn<ObcTableCellData, ObcTableRow>[];
     rowDivider?: boolean;
     narrowHeader?: boolean;
     showHeader?: boolean;
     striped?: boolean;
     selectable?: boolean;
     selectedRowIds?: string[] | undefined;
     defaultSelectedRowIds?: string[] | undefined;
     selectAllAriaLabel?: string
   }

      
  
      export type {ObcTableRowClickEvent, ObcTableCellClickEvent, ObcTableCellCheckboxChangeEvent, ObcTableCellTagClickEvent, ObcTableSelectionChangeEvent, ObcTableRow, ObcTableColumn, ObcTableCellData} from '@oicl/openbridge-webcomponents/dist/components/table/table.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcTable',
  props: {
    data: {},
    columns: {},
    rowDivider: { type: Boolean },
    narrowHeader: { type: Boolean },
    showHeader: { type: Boolean },
    striped: { type: Boolean },
    selectable: { type: Boolean },
    selectedRowIds: {},
    defaultSelectedRowIds: {},
    selectAllAriaLabel: {}
  },
  emits: ["row-click", "cell-button-click", "cell-checkbox-change", "cell-tag-click", "selection-change"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onRowClick: (event: ObcTableRowClickEvent) => emit('row-click', event as ObcTableRowClickEvent),
onCellButtonClick: (event: ObcTableCellClickEvent) => emit('cell-button-click', event as ObcTableCellClickEvent),
onCellCheckboxChange: (event: ObcTableCellCheckboxChangeEvent) => emit('cell-checkbox-change', event as ObcTableCellCheckboxChangeEvent),
onCellTagClick: (event: ObcTableCellTagClickEvent) => emit('cell-tag-click', event as ObcTableCellTagClickEvent),
onSelectionChange: (event: ObcTableSelectionChangeEvent) => emit('selection-change', event as ObcTableSelectionChangeEvent)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-table',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})